import { formatMoney, formatDate } from '../../lib/utils'
import { ehParcelado, escopoBloqueado } from '../../lib/paresImportacao'
import { EscolhaEscopo } from './ImportarEscopo'
import type { EscopoExclusao, Fatura, ItemSomenteNoApp } from '../../types'

const NOMES_MES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export type AcaoSobra = 'manter' | 'mover' | 'excluir'

function Sobra({ x, permiteExcluir, faturaPaga, acao, onAcao, escopo, onEscopo, destino, onDestino, destinos }: {
  x: ItemSomenteNoApp
  permiteExcluir: boolean
  faturaPaga: boolean
  acao: AcaoSobra
  onAcao: (a: AcaoSobra) => void
  escopo: EscopoExclusao
  onEscopo: (e: EscopoExclusao) => void
  destino?: string
  onDestino: (id: string) => void
  destinos: Fatura[]
}) {
  const bloqueadoApenas = !!x.escopos && escopoBloqueado(x.escopos.apenas)
  const semExcluir = !permiteExcluir || faturaPaga || bloqueadoApenas
  const motivo = !permiteExcluir ? 'Veio do banco (Pluggy): não dá para excluir.' : faturaPaga || bloqueadoApenas ? 'Fatura já paga: reabra antes de excluir.' : null
  return (
    <div className="space-y-1 border-t border-line pt-2 first:border-t-0 first:pt-0">
      <div className="flex flex-wrap items-center gap-2 text-13">
        <span className="min-w-40 flex-1 text-white">{x.descricao}{x.parcelaNumero != null && x.parcelaTotalNumero ? ` (parcela ${x.parcelaNumero}/${x.parcelaTotalNumero})` : ''}</span>
        <span className="text-muted">{formatDate(x.data)}</span>
        <span className="font-semibold text-white">{formatMoney(x.valor)}</span>
        <select aria-label="O que fazer" className="rounded border border-line bg-surface px-2 py-1 text-12" value={acao} onChange={(e) => onAcao(e.target.value as AcaoSobra)}>
          <option value="manter">Manter</option>
          <option value="mover" disabled={faturaPaga || destinos.length === 0}>Mover para outra fatura</option>
          <option value="excluir" disabled={semExcluir}>Excluir</option>
        </select>
        {acao === 'mover' && (
          <select aria-label="Fatura de destino" className="rounded border border-line bg-surface px-2 py-1 text-12" value={destino} onChange={(e) => onDestino(e.target.value)}>
            {destinos.map((d) => <option key={d.id} value={d.id}>{NOMES_MES[d.mes - 1]} de {d.ano}</option>)}
          </select>
        )}
      </div>
      {motivo && semExcluir && <p className="text-2xs text-muted">{motivo}</p>}
      {acao === 'excluir' && x.escopos && ehParcelado(x.parcelaNumero, x.escopos) && (
        <div className="pl-2"><EscolhaEscopo nome={`sobra-${x.id}`} escopos={x.escopos} valor={escopo} onChange={onEscopo} /></div>
      )}
    </div>
  )
}

/** Lançamentos do app que não estão no arquivo: manter, mover para outra fatura ou excluir (com escopo se parcelado). */
export function SobrasDoApp({ lista, faturaPaga, rotuloArquivo, acaoDe, onAcao, escopoDe, onEscopo, destinoDe, onDestino, destinos, ehPluggyGrupo }: {
  lista: ItemSomenteNoApp[]
  faturaPaga: boolean
  rotuloArquivo: string
  acaoDe: (id: string) => AcaoSobra
  onAcao: (x: ItemSomenteNoApp, a: AcaoSobra) => void
  escopoDe: (id: string) => EscopoExclusao
  onEscopo: (id: string, e: EscopoExclusao) => void
  destinoDe: (id: string) => string | undefined
  onDestino: (id: string, d: string) => void
  destinos: Fatura[]
  /** Itens do grupo vinculadosPluggy (vale quando a API antiga não manda permiteExcluir). */
  ehPluggyGrupo: (x: ItemSomenteNoApp) => boolean
}) {
  if (lista.length === 0) return null
  return (
    <div className="space-y-2 rounded-lg border border-line p-3">
      <p className="text-13 font-medium text-white">No app, mas não no {rotuloArquivo}</p>
      {faturaPaga && <p className="text-12 text-warning">Fatura já paga: só informativo. Para excluir ou mover, reabra a fatura antes.</p>}
      <p className="text-12 text-muted">Por padrão ficam como estão. Mova ou exclua só o que não pertence a esta fatura.</p>
      {lista.map((x) => (
        <Sobra
          key={x.id} x={x} permiteExcluir={x.permiteExcluir ?? !ehPluggyGrupo(x)} faturaPaga={faturaPaga}
          acao={acaoDe(x.id)} onAcao={(a) => onAcao(x, a)} escopo={escopoDe(x.id)} onEscopo={(e) => onEscopo(x.id, e)}
          destino={destinoDe(x.id)} onDestino={(d) => onDestino(x.id, d)} destinos={destinos}
        />
      ))}
    </div>
  )
}
